import useLangStore from "@/hooks/useLangStore";
import AdBannersRoute from "@/routes/ad-banners";
import BranchesRoute from "@/routes/branches";
import ChallengesRoute from "@/routes/challenges";
import ChooseLangRoute from "@/routes/choose-lang";
import ClientsRoute from "@/routes/clients";
import CustomersRoute from "@/routes/customers";
import DashboardLayoutRoute from "@/routes/dashboard-layout";
import FeedbacksRoute from "@/routes/feedbacks";
import HomeRoute from "@/routes/home";
import LoginRoute from "@/routes/login";
import OrdersRoute from "@/routes/orders";
import ProductsRoute from "@/routes/products";
import ProductsCategoriesRoute from "@/routes/products-categories";
import ProductsListRoute from "@/routes/products-list";
import ProfileRoute from "@/routes/profile";
import SelectStoreRoute from "@/routes/select-store";
import SettingsRoute from "@/routes/settings";
import TiersRoute from "@/routes/tiers";
import PopupPaper from "@/UI/components/PopupPaper";
import { useEffect } from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
    { path: "/choose-lang", element: <ChooseLangRoute /> },
    { path: "/login", element: <LoginRoute /> },
    { path: "/select-store", element: <SelectStoreRoute /> },
    {
        path: "/",
        element: <DashboardLayoutRoute />,
        children: [
            { index: true, element: <HomeRoute /> },
            { path: "branches", element: <BranchesRoute /> },
            {
                path: "products",
                element: <ProductsRoute />,
                children: [
                    { index: true, element: <ProductsListRoute /> },
                    { path: "categories", element: <ProductsCategoriesRoute /> },
                ],
            },
            { path: "tiers", element: <TiersRoute /> },
            { path: "challenges", element: <ChallengesRoute /> },
            { path: "ad-banners", element: <AdBannersRoute /> },
            { path: "customers", element: <CustomersRoute /> },
            { path: "orders", element: <OrdersRoute /> },
            { path: "feedbacks", element: <FeedbacksRoute /> },
            { path: "clients", element: <ClientsRoute /> },
            { path: "settings", element: <SettingsRoute /> },
            { path: "profile", element: <ProfileRoute /> },
        ],
    },
    { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
    const { lang } = useLangStore();

    useEffect(() => {
        document.documentElement.dir = lang === "en" ? "ltr" : "rtl";
        document.documentElement.lang = lang ?? "ar";
    }, [lang]);

    return (
        <>
            <RouterProvider router={router} />
            <PopupPaper />
        </>
    );
}
